export interface InvoiceTotals {
  subTotal: number;
  discountPercent: number;
  discountAmount: number;
  afterDiscount: number;
  vatPercent: number;
  vatAmount: number;
  finalTotal: number;
}

// Keep the project's raw number precision; formatting belongs to display/export.
export function calculateInvoiceTotals(subTotal: number, discount: number | null, vat: number | null): InvoiceTotals {
  const discountPercent = Number(discount) || 0;
  const vatPercent = Number(vat) || 0;
  const discountAmount = subTotal * discountPercent / 100;
  const afterDiscount = subTotal - discountAmount;
  const vatAmount = afterDiscount * vatPercent / 100;
  return { subTotal, discountPercent, discountAmount, afterDiscount, vatPercent, vatAmount,
    finalTotal: afterDiscount + vatAmount };
}

export function invoiceSummaryRows(totals: InvoiceTotals): Array<Array<string | number>> {
  return [
    ['جمع قبل از تخفیف (ریال)', totals.subTotal],
    ['درصد تخفیف', totals.discountPercent],
    ['مبلغ تخفیف (ریال)', totals.discountAmount],
    ['مبلغ پس از تخفیف (ریال)', totals.afterDiscount],
    ['درصد ارزش افزوده', totals.vatPercent],
    ['مبلغ ارزش افزوده (ریال)', totals.vatAmount],
    ['جمع کل نهایی (ریال)', totals.finalTotal]
  ];
}
